var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPromoVolt(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 32,
    viewBox: "0 0 30 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.72682 31.2134C8.37538 26.9114 10.0239 22.6095 11.7087 18.1999C9.51669 18.1999 7.41523 18.1999 5.29566 18.1999C5.25943 18.1461 5.24131 18.0744 5.20508 18.0207C11.0566 12.3026 16.8899 6.58452 22.7414 0.866455C22.7957 0.902305 22.8501 0.92023 22.9044 0.95608C21.4008 5.24015 19.8972 9.54215 18.3573 13.9338C20.5675 13.9338 22.6689 13.9338 24.7704 13.9338C24.7885 13.9875 24.8247 14.0413 24.8428 14.0951C18.8464 19.8311 12.85 25.5671 6.83552 31.321C6.79929 31.2672 6.76306 31.2314 6.72682 31.2134Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.23344 27.8974C1.58124 24.7246 -2.205 16.7122 1.54501 9.04029C5.31314 1.29669 14.0451 -0.890153 20.5125 1.72689C19.9328 2.26464 19.4074 2.80239 18.8096 3.26844C18.6646 3.37599 18.3386 3.30429 18.1212 3.25052C13.0125 2.13917 8.68272 3.50147 5.27691 7.39119C0.657326 12.6791 1.52689 20.8528 7.08851 25.1728C8.10301 25.9615 8.10301 25.9615 7.59576 27.1087C7.48706 27.3596 7.36025 27.6106 7.23344 27.8974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.167 29.2955C10.6924 28.7398 11.1634 28.1662 11.7069 27.6643C11.8337 27.5388 12.1598 27.5388 12.3771 27.5926C17.2866 28.5964 21.4352 27.1983 24.6598 23.5236C27.7758 19.9924 28.5004 15.8518 27.0511 11.3884C26.3084 9.07611 24.8953 7.15813 22.9569 5.65244C22.5402 5.32979 22.504 5.07884 22.7214 4.64864C22.9569 4.20051 23.1562 3.71654 23.3736 3.25049C28.4098 6.29773 32.1417 13.9696 28.6091 21.5519C25.0765 29.17 16.5257 31.6616 10.167 29.2955Z",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoVolt);
export default __webpack_public_path__ + "lbHeaderFiles/static/media/promo-volt.845f2450d2030f204e26fa01614789e9.svg";
export { ForwardRef as ReactComponent };